import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { ACCESS_TOKEN_STORAGE_KEY, AUTHENTICATION_STATE_CLEARED_EVENT } from './api/client';
import { EventProvider } from './contexts/EventContext';
import reportWebVitals from './reportWebVitals';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

const root = ReactDOM.createRoot(rootElement);
const queryClient = new QueryClient();

globalThis.addEventListener(AUTHENTICATION_STATE_CLEARED_EVENT, () => {
  queryClient.clear();
});

globalThis.addEventListener('storage', (event) => {
  if (event.key !== ACCESS_TOKEN_STORAGE_KEY || event.oldValue === event.newValue) {
    return;
  }

  queryClient.clear();
  globalThis.location.reload();
});

root.render(
  <React.StrictMode>
    <BrowserRouter>
        <QueryClientProvider client={queryClient}>
            <EventProvider>
                <App />
            </EventProvider>
        </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
